// URL-слаги машины для страницы авто (/rent/{brand}/{model}/{short_id}).
// Порт логики Солнышко (src/lib/car-slug.ts) БЕЗ префикса локали — у автопилота
// нет /[locale]/. short_id (CRC32→base36) совпадает с тем, что в БД/Go, поэтому
// ссылки стабильны и резолвятся по тому же /fleet.

function slugify(s: string): string {
  return (s || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

export function carBrandModelSlug(name: string): { brand: string; model: string } {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  const brand = slugify(parts[0] || "") || "car";
  const model = slugify(parts.slice(1).join(" ")) || "model";
  return { brand, model };
}

// CRC-32 (IEEE) — как Go crc32.ChecksumIEEE: short id идентичен бэкенду.
function crc32(str: string): number {
  let c = 0xffffffff;
  for (let i = 0; i < str.length; i++) {
    c ^= str.charCodeAt(i);
    for (let j = 0; j < 8; j++) c = (c >>> 1) ^ (0xedb88320 & -(c & 1));
  }
  return (c ^ 0xffffffff) >>> 0;
}

/** Стабильный short id из guid машины (base36, ≥6 символов). Совпадает с БД. */
export function carShortId(guid: string): string {
  const g = (guid || "").trim();
  if (!g) return "";
  return crc32(g).toString(36).toUpperCase().padStart(6, "0");
}

/** Путь к модели: /{city}/rent/{brand}/{model} (город опционален для совместимости). */
export function carPath(name: string, city?: string): string {
  const { brand, model } = carBrandModelSlug(name);
  const prefix = city ? `/${encodeURIComponent(city)}` : "";
  return `${prefix}/rent/${brand}/${model}`;
}

/** Путь к КОНКРЕТНОЙ машине: /{city}/rent/{brand}/{model}/{short_id}. Город
 *  ставится перед rent (по просьбе). Без города — старый /rent/... (тоже рабочий). */
export function carPathWithId(name: string, guid: string, city?: string): string {
  const { brand, model } = carBrandModelSlug(name);
  const prefix = city ? `/${encodeURIComponent(city)}` : "";
  return `${prefix}/rent/${brand}/${model}/${carShortId(guid)}`;
}

/** Имя машины соответствует слагам brand/model? (params приходят URL-encoded). */
export function carMatchesBrandModel(name: string, brand: string, model: string): boolean {
  const s = carBrandModelSlug(name);
  return s.brand === slugify(decodeURIComponent(brand)) && s.model === slugify(decodeURIComponent(model));
}
